module.exports = __webpack_public_path__ + "static/vetement1-b25f43db75cc4f68b63e6751da131062.jpg";